import { useEffect } from 'react';

const useVersionCheck = () => {
    useEffect(() => {
        const checkVersion = async () => {
            try {
                const currentVersion = localStorage.getItem('app_version');
                const response = await fetch(`/version.json?t=${Date.now()}`);
                const versionData = await response.json();
                const serverVersion = versionData.version;

                if (currentVersion && currentVersion !== serverVersion) {
                    console.log(`Nuova versione rilevata: ${serverVersion}. Aggiornamento in corso...`);
                    localStorage.clear();
                    sessionStorage.clear();

                    // Rimuovi SW e cache, poi reload
                    const unregisterSWAndClearCache = async () => {
                        if ('serviceWorker' in navigator) {
                            try {
                                const registrations = await navigator.serviceWorker.getRegistrations();
                                await Promise.all(registrations.map(async (registration) => {
                                    await registration.unregister();
                                    console.log('Service worker disinstallato:', registration.scope);
                                }));
                                if ('caches' in window) {
                                    const cacheNames = await caches.keys();
                                    await Promise.all(
                                        cacheNames.map(cacheName => {
                                            console.log('Cache eliminata:', cacheName);
                                            return caches.delete(cacheName);
                                        })
                                    );
                                }
                            } catch (swError) {
                                console.error('Errore nella rimozione service worker:', swError);
                            }
                        }
                    };

                    await unregisterSWAndClearCache();

                    localStorage.setItem('app_version', serverVersion);
                    // alert("ciao")
                    window.location.reload();
                } else {
                    localStorage.setItem('app_version', serverVersion);
                }
            } catch (error) {
                console.error('Errore nel controllo versione:', error);
            }
        };

        checkVersion();
        const interval = setInterval(checkVersion, 5 * 60 * 1000);
        return () => clearInterval(interval);
    }, []);
};

export default useVersionCheck;